import {Component, input} from '@angular/core';
import {LinkComponent} from '../link/link.component';

@Component({
  selector: 'app-button',
  standalone: true,
  imports: [],
  templateUrl: './button.component.html',
  styleUrl: './button.component.css'
})
export class ButtonComponent extends LinkComponent {
  type = input<'button' | 'submit' | 'reset'>('button');
  variant = input<'primary' | 'secondary' | 'danger'>('primary');
  size = input<'small' | 'base' | 'x-small'>('base');
  form = input<string | null>(null);

  get buttonClass(): string {
    const baseClasses = 'px-4 py-2 rounded-sm not-disabled:cursor-pointer disabled:text-fg-disabled disabled:bg-disabled w-full sm:w-auto not-sm:text-center';
    const variantClasses = {
      primary: 'text-white bg-brand hover:bg-brand-strong focus:ring-4 disabled:border-default border border-brand focus:ring-brand-medium focus:outline-none',
      secondary: 'text-gray-900 focus:outline-none bg-white border border-default hover:bg-gray-100 hover:text-brand focus:z-10 focus:ring-4 focus:ring-gray-100 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:hover:text-white dark:hover:bg-gray-700',
      danger: 'focus:outline-none text-white bg-danger border disabled:border-default border-danger hover:bg-danger-strong focus:ring-4 focus:ring-danger-medium',
    };

    const sizeClasses = {
      small: 'px-3 py-2 text-sm font-medium',
      base: 'py-2.5 px-5  text-sm font-medium',
      'x-small': 'py-.5 px-1 text-xs font-medium'
    }
    return `${baseClasses} ${variantClasses[this.variant()]} ${sizeClasses[this.size()]}`;
  }
}
